import React from 'react';
import { motion } from 'framer-motion';
export function ModernRelevanceSection() {
  return <section id="legacy" className="py-24 md:py-32 bg-[#F5F0E8]" data-id="element-118">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-119">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-120">
          <h2 className="text-sm font-medium tracking-[0.2em] text-[#6B1D1D] uppercase mb-4" data-id="element-121">
            Modern Relevance
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif text-[#1A1A1A]" data-id="element-122">
            His Vision, Our World
          </h3>
        </motion.div>

        <div className="space-y-24" data-id="element-123">
          {/* Section 1 */}
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center" data-id="element-124">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.8
          }} className="md:col-span-5" data-id="element-125">
              <h4 className="text-3xl font-serif text-[#1B2A4A] mb-6" data-id="element-126">
                The Iron Wall Vindicated
              </h4>
              <p className="text-xl text-[#1A1A1A]/80 font-serif italic border-l-2 border-[#1B2A4A] pl-6 py-2" data-id="element-127">
                Peace is the byproduct of undeniable strength, not the result of
                preemptive concession.
              </p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.8
          }} className="md:col-span-7 text-[#1A1A1A]/80 leading-relaxed space-y-4" data-id="element-128">
              <p data-id="element-129">
                Jabotinsky's "Iron Wall" doctrine was often misunderstood as
                warmongering. In reality, it was a pragmatic framework for
                peace. He argued that native populations do not willingly
                surrender their perceived sovereignty; therefore, peace can only
                emerge when the hope of destroying the Jewish state is
                permanently extinguished.
              </p>
              <p data-id="element-130">
                Today, Israel's security doctrine implicitly relies on this
                framework. The Abraham Accords stand as a modern vindication of
                his thesis: normalization with the Arab world occurred not
                through territorial concessions, but through the recognition of
                Israel's permanence, strength, and technological superiority.
              </p>
            </motion.div>
          </div>

          {/* Section 2 */}
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center" data-id="element-131">
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.8
          }} className="md:col-span-5 md:order-last" data-id="element-132">
              <h4 className="text-3xl font-serif text-[#6B1D1D] mb-6" data-id="element-133">
                Liberal Nationalism in an Age of Extremes
              </h4>
              <p className="text-xl text-[#1A1A1A]/80 font-serif italic border-l-2 border-[#6B1D1D] pl-6 py-2" data-id="element-134">
                A third way between globalist erasure of identity and
                ethno-nationalist exclusion.
              </p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.8
          }} className="md:col-span-7 text-[#1A1A1A]/80 leading-relaxed space-y-4" data-id="element-135">
              <p data-id="element-136">
                In an era increasingly polarized between post-national
                universalism and xenophobic populism, Jabotinsky offers a
                coherent alternative. He was an unapologetic nationalist who
                believed deeply in the unique destiny of his people, yet he was
                equally a classical liberal.
              </p>
              <p data-id="element-137">
                He envisioned a state where national identity is celebrated, but
                where the rights of the individual and minorities are
                sacrosanct. His draft constitution for a future Jewish state
                explicitly guaranteed equality for Arab citizens, proving that
                strong national borders and cultural confidence are not
                antithetical to human rights—they are the very foundation that
                secures them.
              </p>
            </motion.div>
          </div>

          {/* Section 3 */}
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center" data-id="element-138">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.8
          }} className="md:col-span-5" data-id="element-139">
              <h4 className="text-3xl font-serif text-[#B8860B] mb-6" data-id="element-140">
                What He Would Say Today
              </h4>
              <p className="text-xl text-[#1A1A1A]/80 font-serif italic border-l-2 border-[#B8860B] pl-6 py-2" data-id="element-141">
                "Eliminate the diaspora, or the diaspora will surely eliminate
                you."
              </p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.8
          }} className="md:col-span-7 text-[#1A1A1A]/80 leading-relaxed space-y-4" data-id="element-142">
              <p data-id="element-143">
                Jabotinsky was a prophet of doom who desperately wanted to be
                proven wrong. His warnings to European Jewry in the 1930s to
                "liquidate the diaspora" were met with derision, yet proved
                tragically prescient.
              </p>
              <p data-id="element-144">
                Looking at today's world, he would likely advocate for an
                unwavering security posture and cultural confidence without
                apology. He would urge the diaspora to recognize the fragility
                of their position and demand that the Jewish state maintain its
                absolute self-reliance. Above all, he would insist on{' '}
                <em data-id="element-145">Hadar</em>—that we face the world not as victims seeking
                sympathy, but as a sovereign people commanding respect.
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}